/**
 * نشانِ ربات کنارِ نامِ صندلی — آیکونِ خطی، نه ایموجی: ایموجی در هر سیستم
 * شکلِ دیگری دارد و صفحه‌خوان آن را «robot face» می‌خوانَد، بی ربط به زبانِ
 * صفحه. این یکی با متنِ جای‌گزینِ فارسی و رنگِ همان متنِ کنارش.
 */
export function BotIcon({ size = 16 }: { size?: number }) {
  return (
    <svg className="boticon" width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="ربات"
         fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <title>ربات</title>
      <rect x="4" y="8" width="16" height="12" rx="3" />
      <path d="M12 8V4M9 4h6" />
      <circle cx="9" cy="14" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="15" cy="14" r="1.3" fill="currentColor" stroke="none" />
      <path d="M9 17.5h6" />
      <path d="M2 12v4M22 12v4" />
    </svg>
  );
}
